import apiClient from './apiClient'
import { API_CONFIG } from './config'
import { mockJobs, delay } from './mockData'

// Fetch jobs by database name
const getJobs = async (databaseName) => {
  if (API_CONFIG.useMockData) {
    console.log('📦 Using mock data: jobs for', databaseName)
    return delay(mockJobs[1])
  }
  
  // Fetch jobs by database name from the API
  const response = await apiClient.get(`/Jobs/database/${databaseName}`)
  return response.data
}

// Legacy method for backward compatibility
const getJobsByAppId = async (applicationId) => {
  if (API_CONFIG.useMockData) {
    console.log('📦 Using mock data: jobs', applicationId)
    return delay(mockJobs[applicationId] || mockJobs[1])
  }
  
  const response = await apiClient.get(`/Jobs/application/${applicationId}`)
  return response.data
}

const jobsService = {
  getJobs,
  getJobsByAppId,
}

export default jobsService
